import { createAsyncThunk } from "@reduxjs/toolkit";
import { organizationAPI } from "libs/apiClient/Organization";

export const getDocumentOrganization = createAsyncThunk(
	"documentsSlice/getDocumentOrganization",
	async ({ organizationId }: { organizationId: number }, { rejectWithValue, dispatch }) => {
		try {
			return await organizationAPI.organizationDetail(organizationId).then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);
